import React from "react";
import moment from "moment";
import { Link } from "react-router";
import { Table, Tr, Td, Sort } from "reactable";
import { RaisedButton } from "material-ui";

import { capitalize } from "../../util";

import AccountEditorModal from "./account-editor-modal.jsx";

import UserActions from "../../actions/UserActions";

const NEW_ACCOUNT = "NEW";

class AccountTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      deletedAccounts: {},
      accountIdBeingEdited: null
    };

    this._edit = this._edit.bind(this);
    this._delete = this._delete.bind(this);
    this._saveAccount = this._saveAccount.bind(this);
    this._dismissAccount = this._dismissAccount.bind(this);
    this._makeRowForAccount = this._makeRowForAccount.bind(this);
  }

  _edit(id, e) {
    e.preventDefault();

    if (id === this.props.selfAccountId) {
      return this.props.onSelfEdit();
    }

    this.setState({ accountIdBeingEdited: id });
  }

  _delete(id, e) {
    e.preventDefault();

    if (
      window.confirm(
        "Are you sure you want to delete this account? There is no going back."
      )
    ) {
      UserActions.deleteAccount(id);
      this.state.deletedAccounts[id] = true;
      this.setState(this.state);
    }
  }

  _saveAccount(account) {
    let id = this.state.accountIdBeingEdited;

    if (id === NEW_ACCOUNT) {
      UserActions.createAccount(account);
    } else {
      UserActions.editAccount(id, account);
    }

    this._dismissAccount();
  }

  _dismissAccount() {
    this.setState({ accountIdBeingEdited: null });
  }

  _makeRowForAccount(account) {
    let isDeleted = this.state.deletedAccounts[account.id],
      isSelf = account.id === this.props.selfAccountId;

    return (
      <Tr
        style={isDeleted && { textDecoration: "line-through", color: "#ccc" }}
        key={account.id}
      >
        <Td column="Name" value={account.name}>
          <span>
            {account.name}
            {isSelf && " (you)"}
          </span>
        </Td>
        <Td column="Email" value={account.email}>
          <span>
            {account.email}{" "}
            {account.sso_last_authenticated_at ? (
              <span style={{ fontWeight: "bold" }}>(via SSO ✅)</span>
            ) : (
              ""
            )}
          </span>
        </Td>
        <Td column="Role" value={account.role}>
          {this.props.roles[account.role] &&
            this.props.roles[account.role].label}
        </Td>
        <Td column="Actions">
          {
            <div>
              <a
                style={isDeleted && { color: "#ccc" }}
                href="#"
                onClick={this._edit.bind(this, account.id)}
              >
                Edit
              </a>
              {!isDeleted && !isSelf && (
                <span>
                  &nbsp;
                  <a href="#" onClick={this._delete.bind(this, account.id)}>
                    Delete
                  </a>
                </span>
              )}
            </div>
          }
        </Td>
      </Tr>
    );
  }

  render() {
    let rows = Object.values(this.props.accounts).map(this._makeRowForAccount);

    return (
      <div>
        {this.state.accountIdBeingEdited ? (
          <AccountEditorModal
            isNew={this.state.accountIdBeingEdited === NEW_ACCOUNT}
            account={this.props.accounts[this.state.accountIdBeingEdited]}
            roles={this.props.roles}
            onSave={this._saveAccount}
            onCancel={this._dismissAccount}
          />
        ) : null}
        <Table
          className="bordered striped responsive-table"
          columns={["Name", "Email", "Role", "Actions"]}
        >
          {rows}
        </Table>
        <RaisedButton
          label="Add new account"
          primary={true}
          style={{ marginTop: 10 }}
          onTouchTap={this._edit.bind(this, NEW_ACCOUNT)}
        />
      </div>
    );
  }
}

export default AccountTable;



// WEBPACK FOOTER //
// ./src/app/components/partials/account-table.jsx